/*!
 * SlabandPack – PuchiPop Hediye Kampanyası
 * Etiket "puchipop-kampanya" olan her ürün için 1 hediye; bundle'larda "puchipop-adet-N" etiketiyle N hediye
 * (N = bundle'daki figür sayısı) sepete otomatik eklenir; ürün çıkarılınca hediye de azaltılır.
 * Kampanyaya ürün eklemek / çıkarmak için sadece etiketi ekleyip kaldırmak yeterli.
 * Kampanyayı kapatmak için: ENABLED değerini false yapın (veya theme.liquid'deki satırı silin).
 */
(function () {
  'use strict';
  if (window.__spPuchiPop) return;
  window.__spPuchiPop = true;

  var CFG = {
    ENABLED: true,
    giftVariantId: 67730216812858, // "Naruto Shippuden – PuchiPop Blind Box (Hediye)" – 0 TL
    giftHandle: 'puchipop-hediye',
    tagMultipliers: { 'puchipop-kampanya': 1 },
    countTagPrefix: 'puchipop-adet-',
    cacheKey: 'sp_puchipop_tags_v2',
    cacheTtlMs: 15 * 60 * 1000,
    debounceMs: 100,
    busyMaxMs: 10000,
    settleMs: 1500,
    reloadGuardKey: 'sp_puchipop_reload',
    maxChangesPer30s: 4
  };
  if (!CFG.ENABLED || !window.fetch) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var running = null;
  var rerun = false;
  var changeTimes = [];
  var halted = false;
  var busyTimer = null;
  var lastTouch = 0; // son sepet etkileşimi (Kaldır / + / - / adet değişikliği)

  // Senkron sürerken ödeme butonunu kısa süreliğine pasif göster (olaylara müdahale etmeden, sadece CSS).
  // Emniyet: en geç busyMaxMs sonra kendiliğinden açılır.
  (function addStyle() {
    try {
      var st = document.createElement('style');
      var GIFT = ':is(.cart-item,[id^="cart-item-"],[id^="main-item-"],[id^="CartItem-"],[id^="CartDrawer-Item-"]):has(a[href*="/products/' + CFG.giftHandle + '"])';
      st.textContent =
        'html.sp-pp-busy [name="checkout"],html.sp-pp-busy a[href*="/checkout"]{pointer-events:none!important;opacity:.5!important;cursor:wait!important}' +
        // Hediye satırında adet kutusu ve Kaldır butonu gösterilmez (müşteri hediye adedini değiştiremez)
        GIFT + ' :is(cart-remove-button,[name="minus"],[name="plus"]){display:none!important}' +
        GIFT + ' quantity-input input{pointer-events:none!important;border:0!important;background:transparent!important}';
      (document.head || document.documentElement).appendChild(st);
    } catch (e) {}
  })();
  function busy(on) {
    try { document.documentElement.classList.toggle('sp-pp-busy', !!on); } catch (e) {}
    clearTimeout(busyTimer);
    if (on) busyTimer = setTimeout(function () { busy(false); }, CFG.busyMaxMs);
  }

  /* ---------- yardımcılar ---------- */
  function log() {
    try { console.info.apply(console, ['[PuchiPop]'].concat([].slice.call(arguments))); } catch (e) {}
  }
  function readCache() {
    try { return JSON.parse(sessionStorage.getItem(CFG.cacheKey) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeCache(c) {
    try { sessionStorage.setItem(CFG.cacheKey, JSON.stringify(c)); } catch (e) { /* yok say */ }
  }
  function getJSON(path) {
    return nativeFetch(root + path, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); });
  }
  function postJSON(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Ürünün etiketlerinden çarpanı bulur (0 = kampanya dışı). Hata olursa null döner.
  function getMultiplier(handle) {
    var cache = readCache();
    var hit = cache[handle];
    if (hit && Date.now() - hit.t < CFG.cacheTtlMs) return Promise.resolve(hit.m);
    return getJSON('products/' + encodeURIComponent(handle) + '.js')
      .then(function (p) {
        var m = 0;
        (p.tags || []).forEach(function (tag) {
          var t = String(tag).trim().toLowerCase();
          var v = CFG.tagMultipliers[t];
          if (t.indexOf(CFG.countTagPrefix) === 0) v = parseInt(t.slice(CFG.countTagPrefix.length), 10);
          if (v > 0 && v <= 50 && v > m) m = v;
        });
        var c = readCache();
        c[handle] = { m: m, t: Date.now() };
        writeCache(c);
        return m;
      })
      .catch(function () { return null; });
  }

  /* ---------- ana senkron ---------- */
  // Sepetteki hediye adedini olması gereken sayıya eşitler. Sepet gerçekten değiştiyse true döner.
  function sync() {
    return getJSON('cart.js').then(function (cart) {
      var giftLines = [];
      var others = [];
      (cart.items || []).forEach(function (it) {
        if (Number(it.variant_id) === CFG.giftVariantId) giftLines.push(it); else others.push(it);
      });

      var handles = [];
      others.forEach(function (it) { if (handles.indexOf(it.handle) === -1) handles.push(it.handle); });

      return Promise.all(handles.map(getMultiplier)).then(function (mults) {
        // Bir ürünün bilgisi alınamadıysa sepete hiç dokunma (yanlışlıkla hediye silinmesin).
        if (mults.some(function (m) { return m === null; })) { log('ürün bilgisi alınamadı, sepete dokunulmadı', handles); return false; }

        var byHandle = {};
        handles.forEach(function (h, i) { byHandle[h] = mults[i]; });

        var target = 0;
        others.forEach(function (it) { target += it.quantity * (byHandle[it.handle] || 0); });

        var current = 0;
        giftLines.forEach(function (it) { current += it.quantity; });

        log('hedef', target, 'sepetteki', current);
        if (current === target && giftLines.length <= 1) return false;

        // Döngü emniyeti: başka bir uygulama sürekli geri değiştiriyorsa dur
        var now = Date.now();
        changeTimes = changeTimes.filter(function (t) { return now - t < 30000; });
        if (changeTimes.length >= CFG.maxChangesPer30s) {
          halted = true;
          log('döngü algılandı, script durdu (başka bir sepet uygulaması çakışıyor olabilir)');
          return false;
        }
        changeTimes.push(now);

        var updates = {};
        if (giftLines.length === 0) {
          // Varyant ID ile update: sepette yoksa ekler, stok yetmezse mevcut stokla sınırlar.
          updates[CFG.giftVariantId] = target;
        } else {
          giftLines.forEach(function (it, i) { updates[it.key] = i === 0 ? target : 0; });
        }

        return postJSON('cart/update.js', { updates: updates }).then(function (newCart) {
          if (!newCart || !newCart.items) { log('sepet güncellenemedi', newCart); return false; }
          var after = 0;
          newCart.items.forEach(function (it) { if (Number(it.variant_id) === CFG.giftVariantId) after += it.quantity; });
          return after !== current;
        });
      });
    });
  }

  /* ---------- sepet görünümünü yenileme ---------- */
  // Temanın constants.js / pubsub.js'i global "const" ve "function" tanımlar; window üzerinde olmayabilir.
  function hasPubSub() {
    try {
      // eslint-disable-next-line no-undef
      return typeof publish === 'function' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !!PUB_SUB_EVENTS.cartUpdate;
    } catch (e) { return false; }
  }

  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function reloadOnce() {
    // Sonsuz yenileme olmasın: 10 sn içinde en fazla 1 kez
    var last = 0;
    try { last = Number(sessionStorage.getItem(CFG.reloadGuardKey) || 0); } catch (e) {}
    if (Date.now() - last > 10000) {
      try { sessionStorage.setItem(CFG.reloadGuardKey, String(Date.now())); } catch (e) {}
      window.location.reload();
    }
  }

  function redrawDrawer() {
    var target = document.querySelector('.cart-drawer-inner');
    if (!target) return Promise.resolve(false);
    return nativeFetch(window.location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.cart-drawer-inner');
        var cur = document.querySelector('.cart-drawer-inner');
        if (src && cur) { cur.replaceWith(src); return true; }
        return false;
      })
      .catch(function () { return false; });
  }

  // Sepet sayfası: <cart-items> bölümünü sunucudan güncel hâliyle çekip yerine koy (sayfa yenilemeden)
  function redrawCartPage() {
    var el = document.querySelector('cart-items[data-section-id]');
    if (!el) return Promise.resolve(false);
    var sid = el.getAttribute('data-section-id');
    return nativeFetch(root + 'cart?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('cart-items');
        var cur = document.querySelector('cart-items[data-section-id]');
        if (src && cur) { cur.innerHTML = src.innerHTML; return true; }
        return false;
      })
      .catch(function () { return false; });
  }

  function refreshUI() {
    if (onCartPage()) {
      redrawCartPage().then(function (ok) { if (!ok) reloadOnce(); });
    } else {
      redrawDrawer().then(function (ok) {
        if (!ok && hasPubSub()) {
          // eslint-disable-next-line no-undef
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'puchipop-gift' }); } catch (e) {}
        }
      });
    }
    getJSON('cart.js').then(function (c) {
      var el = document.getElementById('main-cart-count-header-right');
      if (el) {
        el.innerText = c.item_count;
        el.classList.toggle('hidden', c.item_count === 0);
      }
      document.querySelectorAll('[cart-count-drawer]').forEach(function (n) { n.innerHTML = c.item_count; });
    }).catch(function () {});
  }

  function run(opts) {
    opts = opts || {};
    clearTimeout(timer);
    timer = null;
    if (halted) { busy(false); return Promise.resolve(false); }
    if (running) { rerun = true; return running; }
    busy(true);
    running = sync()
      .then(function (changed) {
        if (changed) {
          if (!opts.silent) refreshUI();
          rerun = true; // düzeltme yapıldı: bir kez daha okuyup teyit et
        }
        return changed;
      })
      .catch(function (e) { if (window.console) console.warn('[PuchiPop]', e); return false; })
      .then(function (changed) {
        running = null;
        var wait = CFG.settleMs - (Date.now() - lastTouch);
        if (rerun) {
          rerun = false;
          schedule();
        } else if (wait > 0) {
          // Temanın isteği hâlâ yolda olabilir: sakinleşme süresi dolunca tekrar kontrol et
          busy(true);
          clearTimeout(timer);
          timer = setTimeout(run, wait + 50);
        } else {
          busy(false); // sepet okundu, hediye sayısı doğru ve etkileşim durulmuş
        }
        return changed;
      });
    return running;
  }

  function schedule() {
    if (!halted) busy(true);
    clearTimeout(timer);
    timer = setTimeout(run, CFG.debounceMs);
  }

  /* ---------- sepet değişikliklerini dinle (hiçbir isteğe müdahale etmeden) ---------- */
  // 1) Temanın kendi "sepet güncellendi" sinyali (ürün ekleme, adet değiştirme, silme)
  function listenPubSub() {
    if (!hasPubSub()) return;
    try {
      // eslint-disable-next-line no-undef
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'puchipop-gift') return;
        schedule();
      });
    } catch (e) {}
  }
  // 2) Başlıktaki sepet sayacı değişirse (başka uygulamaların yaptığı değişiklikler dahil)
  function watchCounter() {
    var el = document.getElementById('main-cart-count-header-right');
    if (!el || !window.MutationObserver) return;
    var last = el.textContent;
    new MutationObserver(function () {
      if (el.textContent !== last) { last = el.textContent; schedule(); }
    }).observe(el, { childList: true, characterData: true, subtree: true, attributes: true });
  }
  // 3) Sepet satırında Kaldır / + / - tıklandığı ANDA ödeme butonunu pasifleştir (tıklamaya müdahale etmeden)
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('cart-remove-button, [name="minus"], [name="plus"], .quantity__button');
    if (t && t.closest('cart-items, cart-drawer-items, cart-drawer, #main-cart-items')) { lastTouch = Date.now(); schedule(); }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('cart-items, cart-drawer-items')) { lastTouch = Date.now(); schedule(); }
  }, true);
  // 4) Sekmeye geri dönüldüğünde
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') schedule();
  });

  /* ---------- sayfa açılışında ---------- */
  function start() { listenPubSub(); watchCounter(); run(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.spPuchiPopSync = run; // test için: konsolda spPuchiPopSync()
  log('aktif');
})();
